import { AxiosResponse } from "axios";
import courseApiRequest from "../../utils/apiUtils/courseApiRequest";
import DynatraceContactDTO from "../../models/teamMap/DynatraceContactDTO";
import WorldMapTeamDTO from "../../models/teamMap/WorldMapTeamDTO";

export function getMapByRegion(region: string) {
    const url = "/worldMap/psm/" + region;
    return courseApiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });
}

export function getDynatraceContactsByRegion(region: string) {
    const url = "/contacts/psm/" + region;
    return courseApiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });
}

export function saveUpdateContacts(contacts: Array<DynatraceContactDTO>) {
    const url = "/contacts/psm/add-update";
    return courseApiRequest.post(url, contacts).then((response: AxiosResponse) => {
        return response;
    });
}

export function saveUpdateWorldMap(mapTeam: Array<WorldMapTeamDTO>) {
    const url = "/worldMap/psm/add-update";
    return courseApiRequest.post(url, mapTeam).then((response: AxiosResponse) => {
        return response;
    });
}




